export const LOGIN_ROUTE = "/vendor-manager";
export const FORGOT_ROUTE = "/vendor-manager/forgot-password";

export const DASHBOARD_ROUTE = "/vendor-manager/dashboard";
export const OTP_ROUTE = "/vendor-manager/otps";
export const PROFILE_ROUTE = "/vendor-manager/otps";
export const ORDER_ROUTE = "/vendor-manager/orders";
export const SCAN_ORDER_ROUTE = "/vendor-manager/scan-orders";

export const GALLERY_ROUTE = "/vendor-manager/gallery";
export const COMMON4 = "/vendor-manager/products";
export const COMMON3 = "/vendor-manager/products";
export const COMMON2 = "/vendor-manager/products";
export const SETTING_ROUTE = "/vendor-manager/setting";




export const ROUTE1 = "/vendor-manager/otps";
export const COMMON1 = "/vendor-manager/common";
export const COMMON5 = "/vendor-manager/common5";
export const COMMON6 = "/vendor-manager/common6";


export const PRODUCT_ROUTE = "/vendor-manager/products";
export const MEALS_ROUTES = "/vendor-manager/meals";
export const REVENUE_ROUTES = "/vendor-manager/revenues";
export const TOP_SELLING_ROUTES = "/vendor-manager/top-selling-products";
export const EMP_ROUTES = "/vendor-manager/emp-feed";
export const EMP_USAGE_ROUTES = "/vendor-manager/no-of-app-users";


export const MENU_EXCEL_ROUTE = "/vendor-manager/menu-excel";
export function  PRODUCT_BY_EXCEL(id){
   return `/vendor-manager/excel-products/${id}`;
}


export function ORDER_DEATILS_PRODUCT_ROUTE(id) {
  return `/vendor-manager/order-details/${id}`;
}
